import React from 'react';
import { ClockIcon, CheckIcon } from 'lucide-react';
import { Section, CTAButton } from './Shared';
import { useCountdown, formatClock } from './UrgencyBanner';
import { PRICE, PRODUCT_NAME, finalIncludes } from '../data/pack';
export const OfferCard = ({
  badge = 'Most Chosen'
}: {
  badge?: string;
}) => <div className="relative flex flex-col rounded-2xl border border-brand-gold/40 bg-brand-ink p-6 text-center md:p-8" data-id="element-191" data-mp="2jjcmxmrwki06">
    <div className="absolute -top-3 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-sm bg-brand-burgundy px-4 py-1 font-display text-[10px] font-semibold uppercase tracking-[0.2em] text-brand-surface md:text-xs" data-id="element-192" data-mp="1vute964xy37k">
      {badge}
    </div>

    <h3 className="mb-3 mt-3 font-display text-sm font-semibold uppercase tracking-[0.16em] text-brand-goldLight md:text-base" data-id="element-193" data-mp="25pv5q8movhdb">
      {PRODUCT_NAME}
    </h3>

    <div className="font-serif text-4xl font-semibold text-brand-surface md:text-5xl" data-id="element-194" data-mp="3h6392c9y2wq1">
      {PRICE}
    </div>
    <p className="mb-6 mt-1 text-[11px] uppercase tracking-[0.18em] text-brand-surfaceLight/50 md:text-xs" data-id="element-195" data-mp="3c7ryfzbtsi6r">
      One-time payment
    </p>

    <p className="mb-3 font-display text-[10px] font-semibold uppercase tracking-[0.2em] text-brand-goldLight/70" data-id="element-196" data-mp="4t5p9ncyvs3b">
      Includes
    </p>
    <ul className="mb-7 space-y-2 text-left" data-id="element-197" data-mp="9ta5rddvkmtj">
      {finalIncludes.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-198" data-mp="erlfzp830zca">
          <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand-goldLight" data-id="element-199" data-mp="eoz79m9ggdsh" />
          <span className="text-sm text-brand-surfaceLight/85" data-id="element-200" data-mp="3das8j6esj3n3">{item}</span>
        </li>)}
    </ul>

    <CTAButton fullWidth className="px-4 py-4 text-[12px] md:text-sm" data-id="element-201" data-mp="3i5xx6czkuwev">
      Get Instant Access — {PRICE}
    </CTAButton>

    <p className="mt-5 text-center text-[10px] text-brand-surfaceLight/50 md:text-[11px]" data-id="element-202" data-mp="3rxvbhslvu4ht">
      Secure Payment · Instant Download · No Subscription
    </p>
  </div>;
export const Pricing = () => <Section id="pricing" className="max-w-4xl" data-id="element-203" data-mp="2zhkihj6cyg7i">
    <div className="mb-10 text-center" data-id="element-204" data-mp="2zg9dxh5394fc">
      <h2 className="font-display text-2xl font-bold uppercase tracking-[0.12em] text-brand-burgundy md:text-4xl" data-id="element-205" data-mp="2zf7v2qhtzdn2">
        Get the Complete Bundle
      </h2>
      <p className="mt-3 font-serif text-base italic text-brand-textLight/80 md:text-lg" data-id="element-206" data-mp="2mh0ajexk9eus">
        One secure payment · No subscription · Instant access
      </p>
    </div>
    <div className="mx-auto max-w-md" data-id="element-207" data-mp="2w71q1ibuloy3">
      <OfferCard data-id="element-208" data-mp="2w8d2e6jd050t" />
    </div>
  </Section>;
export const FinalUrgency = () => {
  const timeLeft = useCountdown(1);
  return <Section className="max-w-3xl" data-id="element-209" data-mp="28jts5lgr1i63">
      <div className="paper-panel rounded-3xl p-6 text-center md:p-10" data-id="element-210" data-mp="23jpctyrkuthg">
        <div className="flex flex-col items-center justify-center gap-3 md:flex-row" data-id="element-211" data-mp="2ig6iqagzzfwm">
          <span className="inline-flex items-center gap-2 font-display text-[11px] font-semibold uppercase tracking-[0.16em] text-brand-burgundy md:text-sm" data-id="element-212" data-mp="2idtx9nc16net">
            <ClockIcon className="h-4 w-4 shrink-0 md:h-5 md:w-5" data-id="element-213" data-mp="3tu0l5omw6otv" />
            Special launch price ends in
          </span>
          <span className="rounded-sm border border-brand-gold/30 bg-brand-ink px-4 py-2 font-display text-2xl font-semibold tabular-nums text-brand-surface md:text-3xl" data-id="element-214" data-mp="3oycz3i3pibsl">
            {formatClock(timeLeft)}
          </span>
        </div>

        <p className="mx-auto mt-7 max-w-xl text-base text-brand-text md:text-lg" data-id="element-215" data-mp="3nflaudd2hmfg">
          The {PRODUCT_NAME} is currently available for only {PRICE}. Start your
          next practice with a complete professional system behind you.
        </p>

        <div className="mt-7" data-id="element-216" data-mp="j1n65wyam6qf">
          <CTAButton className="w-full px-6 py-4 text-[12px] sm:w-auto md:px-10 md:text-sm" data-id="element-217" data-mp="nzyeu4cuqb72">
            Yes, I Want Qigong Mastery
          </CTAButton>
        </div>
      </div>
    </Section>;
};